import createIcon from '../../createIcon';

/**
 * @component @name NoFood
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMjQwMl8yNzA0NCkiPgo8cGF0aCBkPSJNMTEuNTA0NyA4LjM1OTg0TDExLjE1NDcgNC44Mzk4NEgxNi4xNTQ3VjAuODM5ODQ0SDE4LjE1NDdWNC44Mzk4NEgyMy4xNTQ3TDIxLjc3NDcgMTguNjI5OEwxMS41MDQ3IDguMzU5ODRaTTEuMTU0NzMgMjAuODM5OFYyMS44Mzk4QzEuMTU0NzMgMjIuMzg5OCAxLjYwNDczIDIyLjgzOTggMi4xNTQ3MyAyMi44Mzk4SDE1LjE1NDdDMTUuNzA0NyAyMi44Mzk4IDE2LjE1NDcgMjIuMzg5OCAxNi4xNTQ3IDIxLjgzOThWMjAuODM5OEgxLjE1NDczWk0yMi4wNTQ3IDIxLjczOThMMi4yNTQ3MyAxLjkzOTg0TDAuODQ0NzI3IDMuMzQ5ODRMNi41NDQ3MyA5LjA0OTg0QzMuNDM0NzMgOS43MDk4NCAxLjE1NDczIDExLjgyOTggMS4xNTQ3MyAxNC44Mzk4SDEyLjMyNDdMMTQuMzI0NyAxNi44Mzk4SDEuMTU0NzNWMTguODM5OEgxNi4xNTQ3VjE4LjY2OThMMjAuNjQ0NyAyMy4xNTk4TDIyLjA1NDcgMjEuNzM5OFoiIGZpbGw9ImJsYWNrIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMjQwMl8yNzA0NCI+CjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NoFood = createIcon('NoFood', [
  ['g', { clipPath: 'url(#clip0_2402_27044)', key: '1uhl1v' }],
  ['defs', { key: '9ahrjx' }],
]);

export default NoFood;
